// extracted by mini-css-extract-plugin
module.exports = {"description":"m0qEScXr0ntS5Gl2LeaS","path":"bMGhMwohUeq93qtE9lCQ","single":"_sLdSf6Z_AXrVo11FnWL"};